import ApiConnector from './ApiConnector.vue';

// @ts-ignore
ApiConnector.install = (Vue) => {
  Vue.component((ApiConnector as any).options.name, ApiConnector);
};

export default ApiConnector;
